/* Header */

jQuery(document).ready(function ($) {
    $(".c-search .moon-search").click(function () {
        $(".c-search input[id$='txtWord']").focus();
    });

    /* When the enter key is pressed in the search box, redirect to the search page.  This fixes the issue where another form on the page breaks the search box in the header. */
    $(".c-search .form-control").bind("keypress", function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();

            var searchResultsUrl = "/system/search-results/";

            //Check if there is a locale specific version of the search page.
            if ($("#search-results-url")) {
                searchResultsUrl = $("#search-results-url").text().replace("~", "");
            }

            window.location = searchResultsUrl + "?searchtext=" + encodeURIComponent($(".c-search .form-control").val()) + "&searchmode=anyword"
            return false;
        }
    });

});